import { getLogger } from "@expert/logging";
import { useQuery } from "@tanstack/react-query";
import { getPersonalizeCoverageExamples } from "../api";
import { useContentfulClient } from "../ContentfulClientProvider";
import type { Language } from "../types";

const logger = getLogger({
    module: "usePersonalizeCoverage",
    supportTeam: "sales",
});
export const usePersonalizeCoverage = (productSku?: string, language?: Language) => {
    const contentfulClient = useContentfulClient();
    const locale = language ?? "en-US";

    const { data } = useQuery({
        queryKey: ["personalize-coverage", productSku, locale],
        queryFn: async () => await getPersonalizeCoverageExamples(contentfulClient, locale, productSku),
    });
    if (!data) {
        logger.info({ productSku }, "Failed to find personalize coverage examples");
        return [];
    }
    return data;
};
